//<editor-fold desc="node core modules">
// const path = require('path');
//</editor-fold>

//<editor-fold desc="npm modules">
// const fs = require('fs-extra');
// const extend = require('extend');
// const Q = require('q');
// const _ = require('underscore');
// const moment = require('moment');
// const URI = require('urijs');
//</editor-fold>

const isInteger = require(`lodash/isInteger`);

/**
 * @module nllib
 */

/**
 * 转换为int类型数据
 *
 * @class nllib/src/convert/to_int
 * @static
 * @param {object} pObject 要转换的原始数据
 * @param {object} pDefaultValue 转换失败的默认值，默认值为0
 * @return {int} 转换后的数据
 *
 * @demo src/convert/demo/to_int.demo.js
 */
const to_int = function (pObject, pDefaultValue) {
    const value_001 = parseInt(pObject);
    let value_002;
    if (isInteger(value_001)) {
        value_002 = value_001;
    } else {
        const defaultValue = isInteger(pDefaultValue) ? pDefaultValue : 0;
        value_002 = defaultValue;
    }
    return value_002;
};

module.exports = to_int;
